import { NewCaseComponent } from './../new-case/new-case.component';
import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { setTimeout } from 'timers';
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any

@Component({
  selector: 'app-contact-history',
  templateUrl: './contact-history.component.html',
  styleUrls: ['./contact-history.component.scss']
})
export class ContactHistoryComponent implements OnInit {

  contactId = ""
  viewCase = false
  contactFullname = ""

  caseHistoryList: any = []
  chatbotHistoryList: any = []
  emailHistoryList: any = []
  smsHistoryList: any = []

  chatBotLastRow: any = []

  caseStatusList: any

  role: any = {}
  cookieData: any

  isCheckedAll = false
  selectList: any

  agentList: any = []
  userIdReceive = ""
  userList: any = []
  forwardRemark = ""
  submittedForward = false

  forwardTeam: any

  myTeams: any

  cancelRemark = ""
  submittedCancel = false

  emailAndSmsDetail: any = {}
  subTypeDetailTmpList: any
  
  teamList: any

  dtC: any
  dtB: any
  dtE: any
  dtS: any

  @ViewChildren('tbC') tbCase: QueryList<any>;
  @ViewChildren('tbB') tbChatbot: QueryList<any>;
  @ViewChildren('tbE') tbEmail: QueryList<any>;
  @ViewChildren('tbS') tbSMS: QueryList<any>;
  @ViewChild(NewCaseComponent) newCase: NewCaseComponent
  constructor(
    private apiService: ApiService,
    private util: UtilService) { }

  async ngOnInit() {
    let thisTs = this
    //await this.init("")
    $(".select2").select2();
    $("#userIdReceiveHistory").on("change", function () {
      thisTs.userIdReceive = $("#userIdReceiveHistory").find('option:selected').val()
    })
  }

  async init(id: string, fullname: string) {
    if (this.contactId == "") {

      this.contactId = id
      this.contactFullname = fullname

      this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
      this.role = JSON.parse(this.cookieData.role)
      this.myTeams = JSON.parse(this.cookieData.teams)

      await this.callApi()
      //await this.searchCase()
      console.log("history on init")

      // $("#table33").dataTable({
      //   'paginate': false,
      //   'searching': false,
      //   "order": []
      // });
    }
  }

  callApi(): Observable<any> {
    return forkJoin([
      this.searchCase(),
      this.searchChatbot(),
      this.searchEmail(),
      this.searchSMS(),
      this.initDropdown()
    ]);
  }

  async createCase() {
    const url = this.util.baseUrl() + `/newCaseForContact/` + this.contactId
    window.open(url, '_blank');
  }

  async initDropdown(){
    this.caseStatusList = await this.apiService.get("master", "caseStatus")
    this.subTypeDetailTmpList = await this.apiService.get("master", "caseSubTypeDetail")

    this.teamList = await this.apiService.get("master", "callcenterTeam")
    // this.teamList = teams.filter((t: any) => {
    //   return this.myTeams.map((mt: any) => { return mt.dpa_callcenterteamid }).indexOf(t.dpa_callcenterteamid) > -1
    // })

    let para = ""
      this.teamList.forEach((t: any) => {
        if(para != ""){
          para += "&"
        }     
        para += "callcenterteam=" + t.dpa_callcenterteamid
      });

    this.agentList = await this.apiService.get("crmservice", "callcenterProfile", para)

    this.searchEmail()
    this.searchSMS()
  }

  delete() {
    this.getSelectedContact()
    if (this.selectList.length < 1) {
      this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
    }
    else {
      $("#deleteModal").modal('show')
    }
  }

  async forward() {
    this.getSelectedContact()
    if (this.selectList.length != 1) {
      this.util.WarningDialog("กรุณาเลือก 1 รายการ");
    }
    else {

      let inValidStatus: any = this.selectList.filter((s:any) => {
        return s.status != null && s.status.toLowerCase() != "new"  && s.status.toLowerCase() != "inprogress"
      })

      if(inValidStatus != null && inValidStatus.length > 0){
        this.util.WarningDialog("กรุณาเลือกเฉพาะรายการที่มีสถานะเป็น New หรือ Inprogress เท่านั้น")
        return
      }

      try {
        let caseForward: any = this.caseHistoryList.filter((c: any) => {
          return c.incidentid == this.selectList[0].caseId
        })

        let caseForwardSubTypeDetail: any = this.subTypeDetailTmpList.filter((st: any) => {
          return st.dpa_casesubtypedetailid == caseForward[0].dpa_casesubtypedetailid
        })

        let matchTeam: any = this.teamList.filter((t: any) => {
          return t.dpa_callcenterteamid == caseForwardSubTypeDetail[0].dpa_teamownerid
        })
        //console.log(caseForwardSubTypeDetail)
        if (matchTeam != null && matchTeam.length > 0) {
          this.forwardTeam = caseForwardSubTypeDetail[0].dpa_teamownerid
          await this.onForwardTeamChange()

          let matchUser: any = this.userList.filter((u: any) => {
            return u.dpa_customwebuserid == caseForwardSubTypeDetail[0].dpa_caseownerid
          })
          if (matchUser != null && matchUser.length > 0) {
            this.userIdReceive = caseForwardSubTypeDetail[0].dpa_caseownerid
          }
          else{
            this.userIdReceive = ""
          }
        }
        else{
          this.forwardTeam = ""
        }

      }
      catch (e) {
        console.log("ไม่สามารถกำหนดค่าเริ่มต้นได้")
        this.forwardTeam = ""
        await this.onForwardTeamChange()
        this.userIdReceive = ""

      }

      this.submittedForward = false
      this.forwardRemark = ""
      $("#forwardInHistoryModal").modal('show')
    }
  }

  CloseModal(modalID: string) {
    $("#" + modalID).modal("hide")
  }


  async confirmForward() {
    this.submittedForward = true
    let success = 0, fail = 0

    if (this.forwardTeam != null && this.forwardTeam.trim() != "" && this.forwardRemark != null && this.forwardRemark.trim() != "") {
      this.util.ShowWaiting(true)

      let caseId: any = this.selectList[0].caseId
      let req: any = this.caseHistoryList.filter((c: any) => {
        return c.incidentid == caseId
      })

      req[0].customerid = this.contactId
      req[0].dpa_modifiedby = this.cookieData.userId
      req[0].dpa_owningteamid = this.forwardTeam
      req[0].dpa_caseowner = this.userIdReceive
      req[0].dpa_assignby = this.cookieData.userId

      var res = await this.apiService.put("crmservice", "caseIncident-share/" + caseId, req[0]);
      if (this.util.isSuccessResponse(res)) {
        $("#forwardInHistoryModal").modal('hide')
        this.util.SuccessDialog("ส่งต่อ Case สำเร็จ")
      } else {
        this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ")
      }
      
      this.util.ShowWaiting(false)
    }
  }


  async confirmDelete() {
    this.submittedCancel = true

    if (this.cancelRemark.trim() != "") {
      this.util.ShowWaiting(true)
      let success = 0, fail = 0

      let cancelStatus = this.caseStatusList.filter((c:any) => {
        return c.dpa_name != null && c.dpa_name.toLowerCase().trim() == "cancel"
      })

      if(cancelStatus == null || cancelStatus.length == 0){
        this.util.ErrorDialog("ไม่สามารถดึงค่าสถานะยกเลิกได้ กรุณาติดต่อเจ้าหน้าที่")
        return
      }

      for (let i = 0; i < this.selectList.length; i++) {
        let caseId: any = this.selectList[i].caseId
        let req: any = this.caseHistoryList.filter((c: any) => {
          return c.incidentid == caseId
        })
        req[0].customerid = this.selectList[i].customerId
        req[0].dpa_modifiedby = this.cookieData.userId
        req[0].dpa_casestatusid = cancelStatus[0].dpa_casestatusid
        req[0].dpa_remark = this.cancelRemark

        var res = await this.apiService.put("crmservice", "caseIncident/" + caseId, req[0]);
        if (this.util.isSuccessResponse(res)) {
          ++success
        } else {
          ++fail
        }
      }

      //some case fail some case success
      if (fail > 0 && success > 0) {
        this.util.WarningDialog("ลบสำเร็จจำนวน: " + success + " เคส, ลบไม่สำเร็จจำนวน: " + fail + " เคส")
      }
      //no case fail no case success
      else if (fail == 0 && success == 0) {
        this.util.ErrorDialog("ลบ Case ไม่สำเร็จ")
      }
      //fail
      else if (fail > 0 && success == 0) {
        this.util.ErrorDialog("ลบ Case ไม่สำเร็จ")
      }
      //success
      else {
        $("#deleteModal").modal('hide')
        this.util.SuccessDialog("ลบ Case สำเร็จ")
      }
      await this.searchCase()
      this.util.ShowWaiting(false)
    }
  }

  async searchCase() {
    this.caseHistoryList = []
    let para = "contactid=" + this.contactId

    let caseList: any = await this.apiService.get("crmservice", "caseIncident", para)
    this.caseHistoryList = caseList.filter((c: any) => {
      return c.dpa_casestatuscode != null && c.dpa_casestatuscode != "04"
    })
  }

  async searchChatbot() {
    this.chatbotHistoryList = []
    let para = "contactid=" + this.contactId
    $('#tbCase').DataTable().clear().destroy();
    let tmp: any = await this.apiService.get("crmservice", "chatbot", para)

    this.chatBotLastRow = []
    if(tmp != null && tmp.data != null && tmp.data.length > 0){
      this.chatbotHistoryList = tmp.data
      this.chatBotLastRow.push(tmp.data[tmp.data.length - 1])
    }
    else{
      this.chatbotHistoryList = []
    }
  }

  async searchEmail() {
    let para = "channel=1&contactid=" + this.contactId
    this.emailHistoryList = await this.apiService.get("crmservice", "activityHistory", para)
    //this.emailHistoryList = []
  }

  async searchSMS() {
    let para = "channel=2&contactid=" + this.contactId
    this.smsHistoryList = await this.apiService.get("crmservice", "activityHistory", para)
    //this.smsHistoryList = []
  }

  ngAfterViewInit() {
    this.tbCase.changes.subscribe(t => {
      this.initTableCase()
    })
    this.tbChatbot.changes.subscribe(t => {
      this.initTableChatbot()
    })
    this.tbEmail.changes.subscribe(t => {
      this.initTableEmail()
    })
    this.tbSMS.changes.subscribe(t => {
      this.initTableSms()
    })
  }

  ngForRendred() {
    console.log('NgFor is Rendered');
    if (this.dtC == null) {
      this.initTableCase()
    }
    if (this.dtB == null) {
      this.initTableChatbot()
    }
    if (this.dtE == null) {
      this.initTableEmail()
    }
    if (this.dtS == null) {
      this.initTableSms()
    }
  }

  async initTableCase() {
    let thisTs = this
    $("#tbCase td:not(.checkbox-col)").on("click", async function () {
      let url = thisTs.util.baseUrl() + "/caseDetail/" + $(this).parent('tr')[0].id
      window.open(url, "_blank")
    });
    // this.dtC = $("#tbCase").dataTable({
    //   retrieve: true,
    //   'paginate': false,
    //   "order": [],
    //   columnDefs: [{ orderable: false, targets: [0] }]
    // });
  }

  initTableChatbot() {
    $("#tbChatbot tbody tr").on("click", function () {
      $("#chatbotHistoryModal").modal('show')
    });

    // this.dtB = $("#tbChatbot").dataTable({
    //   retrieve: true,
    //   'paginate': false
    // });
  }

  initTableEmail() {
    let thisTs = this
    $("#tbEmail tbody tr").on("click", function () {
      let email = thisTs.emailHistoryList.filter((e:any) => {
        return e.dpa_activityhistoryid == this.id && e.dpa_channel == 1
      })
      if(email == null || email.length  == 0){
        thisTs.util.ErrorDialog("ไม่สามารถดึงข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่")
        return
      }
      thisTs.emailAndSmsDetail = email[0]
      $("#emailHistoryModal").modal('show')
    });

    // this.dtE = $("#tbEmail").dataTable({
    //   retrieve: true,
    //   'paginate': false
    // });
  }

  initTableSms() {
    let thisTs = this
    $("#tbSMS tbody tr").on("click", function () {
      let sms = thisTs.smsHistoryList.filter((s:any) => {
        return s.dpa_activityhistoryid == this.id && s.dpa_channel == 2
      })
      if(sms == null || sms.length  == 0){
        thisTs.util.ErrorDialog("ไม่สามารถดึงข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่")
        return
      }
      thisTs.emailAndSmsDetail = sms[0]
      $("#smsHistoryModal").modal('show')
    });

    // this.dtS = $("#tbSMS").dataTable({
    //   retrieve: true,
    //   'paginate': false
    // });
  }

  async onForwardTeamChange() {
    let tmp: any = await this.agentList.filter((a: any) => {
      return a.dpa_teamidlist.map((ag: any) => { return ag.dpa_callcenterteamid }).indexOf(this.forwardTeam) > -1
    })

    this.userList = []
    tmp.forEach((a: any) => {
      if(this.userList.indexOf(a) == -1 && a.dpa_customwebuserid != this.cookieData.userId){
        this.userList.push(a)
      }
    });
  }

  getSelectedContact() {
    let thisTs = this
    this.selectList = []
    $('.row-checker:checkbox:checked').each(function () {
      let value = {
        caseId: $(this).val(),
        customerId: $(this).prop("name"),
        status: $(this).closest('tr').find('td.status')[0].innerHTML
      }
      thisTs.selectList.push(value)
    })
  }

  onCheckAllChange() {
    $(".row-checker").prop("checked", this.isCheckedAll)
  }

  async save(close: boolean = false, closeForward: boolean = false) {
    this.newCase.submitted = true;
    if (this.newCase.form.valid) {
      this.util.ShowWaiting(true)
      if (this.newCase.isEditMode) {
        if (await this.newCase.updateCase()) {
          this.util.ShowWaiting(false)
          this.util.SuccessDialog("แก้ไขสำเร็จ")
          if (close) {
            window.close();
          }
          if(closeForward){
            $("#forwardModal").modal('hide')
          }
        }
        else {
          this.util.ErrorDialog("แก้ไขไม่สำเร็จ")
          this.util.ShowWaiting(false)
        }
      }
      else {
        let caseId = await this.createCase()
        this.newCase.form.controls["incidentid"].setValue(caseId)

        if (caseId != null) {
          this.util.ShowWaiting(false)
          this.util.SuccessDialog("สร้าง Case สำเร็จ")
          this.newCase.isEditMode = true
          if (close) {
            window.close();
          }
          if(closeForward){
            $("#forwardModal").modal('hide')
          }
        }
        else {
          this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
          this.util.ShowWaiting(false)
        }
      }
    }
  }

  // async bindChatbotAgentName(){
  //   if(this.agentList != null && this.agentList.length > 0){

  //   }
  //   else{
  //     this.util.ShowWaiting(true)
  //     this.agentList = await this.apiService.get("crmservice", "")
  //     this.util.ShowWaiting(false)
  //   }
  //   this.chatbotHistoryList.forEach((c: any) => {
  //     let ag: any = this.agentList.filter((ag: any) => {
  //       c.
  //     })
  //     c.agentName = 
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/app/contact-history/contact-history.component.ts